elabs.VideoService = class {
  constructor() {
    this.videoContainers = document.querySelectorAll('.el-video-container');
    if (this.videoContainers.length === 0) {
      return;
    }

    this.initialiseVideos();

    document.addEventListener('WINDOW_RESIZED_EVENT', () => {
      this.initialiseVideos();
    });
  }

  initialiseVideos = () => {
    this.videoContainers.forEach((container) => {
      const video = container.querySelector('.el-video');
      if (!video) {
        return;
      }

      const videoSrcBreakPoint = parseInt(video.dataset.srcBreakpoint, 10);
      if (videoSrcBreakPoint > 0) {
        const currentSrc = video.dataset.currentSrc;
        const windowWidth = window.innerWidth;

        if (windowWidth >= videoSrcBreakPoint) {
          if (currentSrc !== 'desktop') {
            video.src = video.dataset.srcDesktop;
            video.dataset.currentSrc = 'desktop';
          }
        } else {
          if (currentSrc !== 'mobile') {
            video.src = video.dataset.srcMobile;
            video.dataset.currentSrc = 'mobile';
          }
        }
      }

      const videoHeight = video.offsetHeight;
      const containerHeight = container.offsetHeight;

      if (videoHeight < containerHeight) {
        video.style.height = '100%';
        video.style.width = 'auto';
      } else {
        video.style.height = 'auto';
        video.style.width = '100%';
      }
    });
  };
};

elabs.onJavascriptReady(() => {
  elabs.VideoService = new elabs.VideoService();
});
